import React from "react";

const VisitorsContext = React.createContext();

export const VisitorsProvider = VisitorsContext.Provider;
export const VisitorsConsumer = VisitorsContext.Consumer;

export default VisitorsContext;